export enum View {
    COMPACT = "Compact",
    DETAIL = "Detail",
  }